<template>
    <div id="searchinfo">
        <h3 class="clear-block">
            <span class="searchinfo-text">検索対象</span>
        </h3>
        <div class="searchinfo-main">
            <div v-for="(item, index) in items" :key="index" class="row">
                <slot v-bind:item="item" v-if="item.value.length > 0">
                    <p class="entitle fleft box">{{ item.entitle }}</p>
                    <p class="value fleft box">{{ item.value }}</p>
                </slot>
            </div>
        </div>
        <div class="searchinfo-footer"></div>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "SearchInfo",
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
});
</script>

<style>
/*---------------------------
 * searchinfo
 *--------------------------*/
#searchinfo {
    background-color: white;
    border: medium none;
    border-bottom: 1px dotted #cccccc;
    margin-top: 5px;
    overflow: hidden;
    /*padding-top: 20px;*/
    padding-bottom: 5px;
    margin-bottom: 20px;
}
#searchinfo h3 {
    border-bottom: 1px solid #cccccc;
    border-top: 1px solid #cccccc;
    margin-bottom: 10px;
    padding: 5px 10px;
    height: 2em;
    background-image: none;
}
#searchinfo h3 .searchinfo-text {
    float: left;
    /*font-size: 110%;
    font-weight: bold;*/
}
/* #searchinfo h3 .searchinfo-save {
    float: right;
}
#searchinfo h3 .searchinfo-footer {
} */
#searchinfo p.entitle {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
    width: 100px;
}
#searchinfo p.value {
    margin-bottom: 0;
    margin-top: 0;
    width: 550px;
}
#searchinfo p.value::before {
    content: ": ";
}
#searchinfo div.row {
    padding-left: 10px;
}
#searchinfo::after {
    clear: both;
    content: "";
    display: block;
    overflow: hidden;
}
div.row .box {
    display: inline;
}
</style>
